// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.101.2_esbuild@0.25.9_postcss@8.5.6_/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.101.2_esbuild@0.25.9_postcss@8.5.6_/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.address-card-list {
  max-height: 272px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.address-card-list .address-card {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border: 1px solid #dee2e6;
  border-radius: 10px;
  cursor: pointer;
  transition: border-color 0.2s ease, background-color 0.2s ease;
  background-color: #fff;
}
.address-card-list .address-card.selected {
  border-color: var(--primary, #0099e5);
  background-color: #f0f8ff;
}
.address-card-list .address-card .address-card-radio {
  flex-shrink: 0;
}
.address-card-list .address-card .address-card-info {
  flex: 1;
  min-width: 0;
}
.address-card-list .address-card .address-card-info .address-card-name {
  font-weight: 600;
  font-size: 13px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.address-card-list .address-card .address-card-info .address-card-detail {
  font-size: 11px;
  color: #6c757d;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-top: 2px;
}
.address-card-list .address-card .address-card-actions {
  flex-shrink: 0;
  display: flex;
  gap: 4px;
}
.address-card-list .address-card .address-card-actions .addr-icon-btn {
  border: none;
  background: none;
  padding: 5px 7px;
  border-radius: 6px;
  color: #6c757d;
  font-size: 13px;
  cursor: pointer;
  transition: color 0.2s, background-color 0.2s;
}
.address-card-list .address-card .address-card-actions .addr-icon-btn:hover {
  color: var(--primary, #0099e5);
  background-color: #f0f0f0;
}

@media (max-width: 767px) {
  .site-main-content {
    margin-top: 53px;
  }
}
input[type=number]::-webkit-outer-spin-button,
input[type=number]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type=number] {
  -moz-appearance: textfield;
  /* Firefox */
}`, "",{"version":3,"sources":["webpack://./src/app/components/checkout/checkout.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AACF;AACE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,8DAAA;EACA,sBAAA;AACJ;AACI;EACE,qCAAA;EACA,yBAAA;AACN;AAEI;EACE,cAAA;AAAN;AAGI;EACE,OAAA;EACA,YAAA;AADN;AAGM;EACE,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AADR;AAIM;EACE,eAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;AAFR;AAMI;EACE,cAAA;EACA,aAAA;EACA,QAAA;AAJN;AAMM;EACE,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,6CAAA;AAJR;AAMQ;EACE,8BAAA;EACA,yBAAA;AAJV;;AAWA;EACE;IACE,gBAAA;EARF;AACF;AAWA;;EAEE,wBAAA;EACA,SAAA;AATF;;AAYA;EACE,0BAAA;EACA,YAAA;AATF","sourcesContent":[".address-card-list {\n  max-height: 272px;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n\n  .address-card {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 10px 12px;\n    border: 1px solid #dee2e6;\n    border-radius: 10px;\n    cursor: pointer;\n    transition: border-color 0.2s ease, background-color 0.2s ease;\n    background-color: #fff;\n\n    &.selected {\n      border-color: var(--primary, #0099e5);\n      background-color: #f0f8ff;\n    }\n\n    .address-card-radio {\n      flex-shrink: 0;\n    }\n\n    .address-card-info {\n      flex: 1;\n      min-width: 0;\n\n      .address-card-name {\n        font-weight: 600;\n        font-size: 13px;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n      }\n\n      .address-card-detail {\n        font-size: 11px;\n        color: #6c757d;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        margin-top: 2px;\n      }\n    }\n\n    .address-card-actions {\n      flex-shrink: 0;\n      display: flex;\n      gap: 4px;\n\n      .addr-icon-btn {\n        border: none;\n        background: none;\n        padding: 5px 7px;\n        border-radius: 6px;\n        color: #6c757d;\n        font-size: 13px;\n        cursor: pointer;\n        transition: color 0.2s, background-color 0.2s;\n\n        &:hover {\n          color: var(--primary, #0099e5);\n          background-color: #f0f0f0;\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 767px) {\n  .site-main-content {\n    margin-top: 53px;\n  }\n}\n\ninput[type=\"number\"]::-webkit-outer-spin-button,\ninput[type=\"number\"]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\ninput[type=\"number\"] {\n  -moz-appearance: textfield;\n  /* Firefox */\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
